import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import scrollToEl from "../utils/scrollToEl";

export default async block => { // 'comp-expand-blocks'
	const expand = domWrap(block);
	let trigger = 0,
		triggerEnd = 0,
		fixed = false,
		button = expand.querySelector('header button'),
		before = domWrap(button?.previousElementSibling),
		items = [...expand.querySelectorAll(':scope > article > *')],
		itemCount = items.length;

	if(itemCount === 0) {
		expand.setAttribute('empty','empty');
		return;
	}
	if(itemCount === 1 && items[0].tagName.toLowerCase() === 'comp-video'){
		expand.querySelector('header > comp-background')
			.insertAdjacentHTML('beforeend',`<a role="button" class="btn btn-default resource-item" type="VID" jwpid="${items[0].getAttribute('jwpid')}"></a>`);
		button.remove();
		expand.setAttribute('single','video');
		return;
	}

	expand.querySelector('header').addEventListener('click',() => {
		console.log(expand.getAttribute('collapsed'));
		if(!expand.hasAttribute('collapsed')){
			expand.setAttribute('collapsed','collapsed');
			setTimeout(() => scrollToEl(expand.querySelector('header'),true),100);
		}
		else {
			expand.removeAttribute('collapsed');
			scrollToEl(expand.querySelector('header'));
		}
		setTimeout(findTrigger,300);
	});

	function findTrigger(){
		trigger = before.offset().top + before.offsetHeight - 50;
		triggerEnd = expand.offset().top + expand.offsetHeight - 100;
	}
	window.addEventListener('resize',findTrigger);
	window.addEventListener('load',findTrigger);
	findTrigger();

	function scrollCheck(e){
		var scrollTop = window.scrollY,
			makeFixed = scrollTop > trigger && scrollTop < triggerEnd;
		//console.log(makeFixed,scrollTop,trigger,triggerEnd);
		if(makeFixed !== fixed){
			fixed = makeFixed;
			expand.classList.toggle('button-fixed',fixed);
		}
	}
	window.addEventListener('scroll',scrollCheck);
	scrollCheck();
};